module.exports = __webpack_public_path__ + "static/img/woman.d2e4646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman.png
// module id = J3eb
// module chunks = 1